import slugify from "utils/slugifyURLComponent";

import locations, { StaticLocation } from "../../../constants/finder/locations";
import states, { stateData } from "../../../constants/states";
import { normalizeFinderLocation } from "../../locationUtils";

export default (city = "", state = "") => {
  const normalizedCity = slugify(city);
  const normalizedState = slugify(state);

  const foundState = states.find((st) => st.slug === normalizedState);
  const stateCode = foundState?.short;

  if (isCityCached(normalizedCity, stateCode)) {
    return normalizeFinderLocation(
      locationData[`${normalizedCity}-${stateCode}`],
    );
  } else if (isStateCached(normalizedCity, normalizedState)) {
    return normalizeFinderLocation(locationData[normalizedState]);
  }
  return undefined;
};

function isCityCached(city: string | undefined, stateCode: string | undefined) {
  return city && stateCode && locationData[`${city}-${stateCode}`];
}

function isStateCached(city: string | undefined, state: string | undefined) {
  return !city && state && locationData[state];
}

const locationData: Record<string, Partial<StaticLocation>> = {
  ...stateData,
  ...locations,
};

export const estimateLocationRadius = (city: string | undefined) =>
  city ? 34 : 528;
